import { useIsSemDiscoverPage } from "@faire/retailer-visitor-shared/lib/useIsSemDiscoverPage";
import { Flex, HorizontalLine } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { cn } from "@faire/web--source/tools/cn";
import React from "react";

import { FooterCTA } from "./FooterCTA";
import { FooterSection } from "./FooterSection";
import { LegalLinks } from "./LegalLinks";

interface IPropTypes {
  className?: string;
  noTopBorder?: boolean;
  childFirst?: boolean;
  children?: React.ReactNode;
  hideReferral?: boolean;
  showRetailerFooterForNewFooterXP?: boolean;
  isNewsroomPage?: boolean;
}

export const Batch8NewFooter: React.FC<
  IPropTypes & {
    ref?: React.Ref<HTMLDivElement>;
  }
> = ({
  ref,
  className,
  noTopBorder,
  hideReferral,
  showRetailerFooterForNewFooterXP,
  isNewsroomPage,
}) => {
  const isSemDiscoverPage = useIsSemDiscoverPage();
  //TODO: Add variations for CTAs

  if (isSemDiscoverPage) {
    return null;
  }

  return (
    <div
      ref={ref}
      className={cn(
        "position-relative bg-core-surface-inverse w-full",
        className
      )}
    >
      {noTopBorder ? null : <HorizontalLine />}
      <footer className="mx-auto flex w-full flex-col justify-between self-stretch overflow-auto px-4 py-8 md:px-6 lg:p-12 2xl:p-20">
        <Flex
          justify={{
            mobileAndAbove: "flex-start",
            tabletAndAbove: "space-between",
          }}
          align="flex-start"
          direction={{
            mobileAndAbove: "column",
            tabletAndAbove: "row",
          }}
        >
          <FooterCTA
            isNewsroomPage={isNewsroomPage}
            hideReferral={hideReferral}
            showRetailerFooterForNewFooterXP={showRetailerFooterForNewFooterXP}
          />

          <HorizontalLine
            width="100vw"
            margin="0 -16px"
            className="md:hidden"
          />
          <FooterSection />
        </Flex>
        <Spacer size={{ mobileAndAbove: "2x", tabletAndAbove: "4x" }} />
        <LegalLinks />
        <Spacer size={{ mobileAndAbove: "7x", tabletAndAbove: "2x" }} />
      </footer>
    </div>
  );
};
